import { API } from '@aws-amplify/api'
import { WOMA_API_GATEWAY_NAME } from '../../constants/aws'
import { userLogin, userLoginError, setAppConfigurations, filterProcedureCode, setCredentials } from '../actions'

const GET_APP_CCONFIGURATIONS_API = 'app-config'

export const getAppConfig =
  ({ userLoginId, name }) =>
  async (dispatch) => {
    if (!userLoginId) return

    try {
      const options = {
        // headers: {},
        response: false,
      }

      const appConfigurations = await API.get(
        WOMA_API_GATEWAY_NAME,
        `/${GET_APP_CCONFIGURATIONS_API}/${userLoginId}`,
        options,
      )

      const { user_role, id, procedure_codes, user_name } = appConfigurations

      const procedureCodeMap = procedure_codes.map((value) => {
        return {
          id: value.cdx_procedure_code,
          display: value.cdx_procedure_code + ' - ' + value.description,
        }
      })
      dispatch(
        filterProcedureCode({
          payload: {
            procedureCodeMap,
          },
        }),
      )

      dispatch(
        userLogin({
          payload: {
            user: id[0],
            userLogin: userLoginId,
            name: name,
            role: user_role[0],
            isAppConfigSuccessful: true,
            multiple_classifiers_allowed: user_name[0].multiple_classifiers_allowed,
          },
        }),
      )

      dispatch(setAppConfigurations({ payload: appConfigurations }))
    } catch (error) {
      if (error instanceof Object) {
        const err = error.toString().split('\\n')[0]
        dispatch(userLoginError({ errorMessage: err.substring(7, err.length), isAppConfigSuccessful: true }))
      } else {
        dispatch(userLoginError({ errorMessage: error, isAppConfigSuccessful: true }))
      }
      console.log('Authentication Error', error)
    }
  }

export const addCredentials = (credentials) => async (dispatch) => {
  dispatch(setCredentials({ payload: { credentials: credentials } }))
}
